import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { isEmpty } from '@app/util/util';
import {
  ButtonLabels, ButtonType, ButtonSize, ButtonSizeConfig, ButtonSizeConfigProps, ButtonWidth
} from '@design-system/components/molecules/button/entities/button.types';
import { LoaderRingType } from '@design-system/components/atoms/loader-ring/entities/loader-ring.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { CircularBorderRadiusDs } from '@design-system/entities/border-radius.type';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    LoaderRingDsComponent,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class ButtonDsComponent {

  @Input() type = ButtonType.Primary;
  @Input() size = ButtonSize.RG;
  @Input() labels: ButtonLabels;
  @Input() icon: Icon;
  @Input() isDisabled = false;
  @Input() emitWhenDisabled = false;
  @Input() isLoading = false;
  @Input() showIcon = false;
  @Input() isBasket = false;
  @Input() buttonWidth = ButtonWidth.Stretch;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly borderRadius = CircularBorderRadiusDs;

  constructor() { }

  get isVisible(): boolean {
    return this.hasLabelsThatCorrespond || this.isOnlyIconVisible;
  }

  get isOnlyIconVisible(): boolean {
    return this.showIcon && !this.hasLabelsThatCorrespond;
  }

  get hasLabelsThatCorrespond(): boolean {
    return !isEmpty(this.labels?.ButtonLabel) && (
      this.isBasket ? !isEmpty(this.labels?.BasketLabel) : true
    );
  }

  get buttonConfig(): ButtonSizeConfigProps {
    return ButtonSizeConfig[this.size] ?? null;
  }

  get isSquareSize(): boolean {
    return this.size === ButtonSize.SquareRG || this.size === ButtonSize.SquareSM;
  }

  get loaderRingType(): LoaderRingType {
    return this.type === ButtonType.Primary || (this.isLoading && this.isDisabled) ?
      LoaderRingType.Primary : LoaderRingType.Secondary;
  }

  get realButtonWidth(): string {
    return this.isSquareSize ? this.buttonConfig?.Height : this.isOnlyIconVisible ? '82px' : this.buttonWidth;
  }

  public clickTrigger(): void {
    if (!this.isLoading && (this.emitWhenDisabled || !this.isDisabled)) {
      this.clickEvent.emit();
    }
  }

}
